import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';
import { Contact, HideContactData, ViesCheck, ViesInfo } from './models';
import { TOKEN_ID_HEADER } from 'store/app/constants';

export interface GetViesInfoResponse extends ApiResponse {
  data: ViesInfo;
}
export const getViesInfo = (
  connectionId: string
): Promise<GetViesInfoResponse> =>
  api.get<GetViesInfoResponse>(`/vies/get/info/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export const activateVies = (connectionId: string): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/vies/activate/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export const deactivateVies = (connectionId: string): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/vies/deactivate/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export interface GetViesContactsResponse extends ApiResponse {
  data: { contacts: Contact[] };
}
export const getViesContacts = (
  connectionId: string
): Promise<GetViesContactsResponse> =>
  api.get<GetViesContactsResponse>(`/vies/get/contacts/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export interface GetContactResponse extends ApiResponse {
  data: { viesChecks: ViesCheck[]; contact: Contact };
}
export const getContact = (
  connectionId: string,
  contactUuid: string
): Promise<GetContactResponse> =>
  api.get<GetContactResponse>(
    `/vies/get/logs/contact/${connectionId}/${contactUuid}`,
    {
      headers: {
        [TOKEN_ID_HEADER]: connectionId,
      },
    }
  );

export interface CheckContactsResponse extends ApiResponse {
  data: { lastViesCheckDate: string; contacts: Contact[] };
}
export const checkContacts = (
  connectionId: string
): Promise<CheckContactsResponse> =>
  api.post<CheckContactsResponse>(`/vies/check/contacts/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export interface CheckContactResponse extends ApiResponse {
  data: { viesChecks: ViesCheck[]; contact: Contact };
}
export const checkContact = (
  contactUuid: string,
  connectionId: string
): Promise<CheckContactResponse> =>
  api.post<CheckContactResponse>(
    `/vies/check/contact/${contactUuid}/org/${connectionId}`,
    {
      headers: {
        [TOKEN_ID_HEADER]: connectionId,
      },
    }
  );

export const refreshContacts = (connectionId: string): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/vies/refresh/contacts/org/${connectionId}`, {
    headers: {
      [TOKEN_ID_HEADER]: connectionId,
    },
  });

export const refreshContact = (
  contactId: string,
  connectionId: string
): Promise<ApiResponse> =>
  api.post<ApiResponse>(
    `/vies/refresh/contacts/${contactId}/org/${connectionId}`,
    {
      headers: {
        [TOKEN_ID_HEADER]: connectionId,
      },
    }
  );

export const hideContact = (
  hideContactData: HideContactData,
  connectionId: string
): Promise<ApiResponse> => {
  return api.post<ApiResponse>(
    `/vies/contact/org/${connectionId}/mute?isActive=${hideContactData.isActive}`,
    {
      body: { contactUuids: hideContactData.contactsToHide },
      headers: {
        [TOKEN_ID_HEADER]: connectionId,
      },
    }
  );
};
